import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import OrderInvoiceListPageUI from './OrderInvoiceListPageUI.js'
import LocalStorageKeys from '../../cache/LocalStorageKeys'

class OrderInvoiceListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      order: null,
      invoiceList: null,
      filteredInvoiceList: null,
      createInvoiceMode: false,
      searchFilter: ''
    }
  }

  render() {
    return (
      <OrderInvoiceListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        order={this.state.order}
        invoiceList={this.state.invoiceList}
        filteredInvoiceList={this.state.filteredInvoiceList}
        searchFilter={this.state.searchFilter}
        // events
        onRefreshClick={this.onRefreshClick}
        onSearchFilterChange={this.onSearchFilterChange}
        // create modal
        createInvoiceMode={this.state.createInvoiceMode}
        onCreateInvoiceClick={(event) => { this.setState({createInvoiceMode: true}) }}
        onCancelCreateInvoice={(event) => { this.setState({createInvoiceMode: false}) }}
        onCreateInvoiceComplete={this.onCreateInvoiceComplete}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getOrder(context)
    this.getInvoices(context)
    this.getMessages(context)
  }

  getOrder(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/estimates/${this.props.match.params.orderId}`,
      cacheKey: CacheKeys.Order(this.props.match.params.orderId),
      callback: this.getOrderCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getOrderCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      order: response.estimate,
    })
  }

  getInvoices(context) {
    if (!context.permissions) { // session expired for some reason
      localStorage.removeItem(LocalStorageKeys.Session)
      localStorage.removeItem(LocalStorageKeys.Session + ':CachedTime')
      setTimeout(() => {
        window.location = '/pub/message?key=invalid_session'
      }, 10)
      return
    }

    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/estimates/${this.props.match.params.orderId}/invoices`,
      cacheKey: CacheKeys.OrderInvoices(this.props.match.params.orderId),
      callback: this.getInvoicesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getInvoicesCallback = (response) => {
    let filtersStr = sessionStorage.getItem(CacheKeys.OrderInvoicesFilter(this.props.match.params.orderId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      errorList: response.errorList,
      invoiceList: response.invoiceList,
      filteredInvoiceList: response.invoiceList,
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
    })

    this.applyFilters(response.invoiceList, filters.searchFilter ? filters.searchFilter : '')
  }

  applyFilters(invoiceList, searchFilter) {
    let filteredList = invoiceList

    if (searchFilter)
      filteredList = filteredList.filter(invoice =>
        invoice.invoiceName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase())
      )

    this.setState({filteredInvoiceList: filteredList})

    let filters = {
      searchFilter: searchFilter,
    }
    sessionStorage.setItem(CacheKeys.OrderInvoicesFilter(this.props.match.params.orderId), JSON.stringify(filters))
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Order(this.props.match.params.orderId))
    CacheManager.removeObject(CacheKeys.OrderInvoices(this.props.match.params.orderId))
    this.setState({
      errorList: null,
      invoiceList: null,
      filteredInvoiceList: null,
      order: null
    }, () => {
      this.getOrder(context)
      this.getInvoices(context)
    })
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({searchFilter: searchFilter})
    this.applyFilters(this.state.invoiceList, searchFilter)
  }

  onCreateInvoiceComplete = (invoice) => {
    CacheManager.removeObject(CacheKeys.OrderInvoices(invoice.customerOrderId))
    this.setState({ invoice: invoice })
    setTimeout(() => {
      this.setState({ createInvoiceMode: false })
      this.props.history.push(`/invoices/${invoice.customerInvoiceId}`)
    }, 2000)
  }

  getMessages(context) {
    let arr = [
      'c_refresh', //done
      'c_create_invoice',
      'c_no_invoice_msg',
      'c_invoice_total',
      'c_cust_order',
      'c_order_date',
      'c_payments',
      'c_last_sent',
      'c_status_unpaid',
      'c_status_paid',
      'c_cancelled',
      'c_items',
      'c_budgets',
      'c_invoices',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_ord_invs', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(OrderInvoiceListPageSF)
